module.exports = __webpack_public_path__ + "static/media/icon-balizamiento.e33f18e6.svg";